import { DateFormat, t } from '@lingui/macro'
import { Button, TextField } from '@material-ui/core'
import React, { useCallback, useRef } from 'react'
import { IAccount } from 'shopify-payment-core'

import { Brick } from '../atoms/Brick'
import { InfoLine } from '../atoms/InfoLine'
import { useRoot } from '../atoms/RootProvider'
import { useAccountUpdate } from '../hooks/useAccountUpdate'
import { i18n } from '../i18n'

interface IProps {
  account: IAccount
}

export const AccountBlocking: React.FC<IProps> = ({ account }) => {
  const { auth } = useRoot()
  const update = useAccountUpdate(
    account,
    account.blocked ? i18n._(t`Účet odblokován`) : i18n._(t`Účet zablokován`),
  )
  const reasonRef = useRef<HTMLInputElement | null>(null)
  const onToggle = useCallback(
    () => {
      if (account.blocked) {
        update({
          blocked: false,
          blockedBy: null,
          blockedReason: null,
          blockedSince: null,
        })
      } else {
        update({
          blocked: true,
          blockedBy: auth.uid,
          blockedReason: reasonRef.current!.value.trim(),
          blockedSince: new Date().toISOString(),
        })
      }
    },
    [account],
  )
  return (
    <Brick title={i18n._(t`Blokace účtu`)} admin={true}>
      <TextField
        id="blockedReason"
        label={i18n._(t`Důvod blokace`)}
        defaultValue={account.blockedReason}
        inputRef={reasonRef}
        disabled={account.blocked}
        helperText={i18n._(t`Uživatel uvidí důvod blokace po přihlášení!`)}
        fullWidth
        multiline
      />
      {account.blockedSince ? (
        <InfoLine label={i18n._(t`Blokováno od`)}>
          <DateFormat value={new Date(account.blockedSince)} />{' '}
          <DateFormat
            value={new Date(account.blockedSince)}
            format={{ hour: 'numeric', minute: 'numeric' }}
          />
        </InfoLine>
      ) : (
        <br />
      )}
      <br />
      <Button
        variant="contained"
        onClick={onToggle}
        color={account.blocked ? 'primary' : 'secondary'}
      >
        {account.blocked
          ? i18n._(t`Odblokovat účet`)
          : i18n._(t`Zablokovat účet`)}
      </Button>
    </Brick>
  )
}
